import React, { useState, useEffect } from 'react';
import { object, func, bool, string } from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import { MESSAGE_MODALS } from '../../../context/custom/MessageModalContext';
import { ALERT_TYPE, ShowToastMessage, sequenceActionNext } from '@laramie/ui';
import { TableCustom } from '../../common';
import { getDateToString } from '../../../utils/convert';
import { useEntidad, useLista, useManagedContext } from '../../hooks';
import CertificadoApremioPersonaModal from '../CertificadoApremioPersonaModal';
import { isNull } from '../../../utils/validator';

const CertificadoApremioPersonaGrid = (props) => {
    const { showMessageModal } = useManagedContext()

    //hooks
    const [state, setState] = useState({
        idCertificadoApremio: 0,
        disabled: false,
        showForm: false,
        modeFormEdit: false,
        rowForm: null,  
        list: []
    });

    const dispatch = useDispatch();
    const sequenceValue = useSelector( (state) => state.sequence.value );

    const mount = () => {
        setState(prevState => {
        const list = props.data.list.filter(x => x.state !== 'r');
        return {...prevState,
            idCertificadoApremio: props.data.idCertificadoApremio,
            list: list };
        });
    }
    useEffect(mount, [props.data]);

    const [, getRowEntidad] = useEntidad({
        entidades: ['TipoRelacionCertificadoApremioPersona'],
        onLoaded: (entidades, isSuccess, error) => {
            if (isSuccess) {
                setState(prevState => ({...prevState}));
            }
            else {
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
            }
        },
        memo: {
            key: 'TipoRelacionCertificadoApremioPersona',
            timeout: 0
        }
    });  

    const [, getRowLista ] = useLista({
        listas: ['TipoDocumento'],
        onLoaded: (listas, isSuccess, error) => {
          if (isSuccess) {

          }
          else {
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
          }
        },
        memo: {
          key: 'TipoDocumento',
          timeout: 0
        }
    });

    const cellA = (data) =>    <div className='action'>
                                    {!props.disabled && (
                                    <div onClick={ (event) => handleClickCertificadoApremioPersonaAdd() } className="link">
                                        <span className="material-symbols-outlined" title="Nuevo">add</span>
                                    </div>
                                    )}
                                </div>
    const cellVMR = (data) =>  <div className='action'>
                                    <div onClick={ (event) => handleClickCertificadoApremioPersonaView(data.value) } className="link">
                                    <span className="material-symbols-outlined" title="Ver">search</span>
                                    </div>
                                    {!props.disabled && (
                                    <div onClick={ (event) => handleClickCertificadoApremioPersonaModify(data.value) } className="link">
                                        <span className="material-symbols-outlined" title="Modificar">stylus</span>
                                    </div>
                                    )}
                                    {!props.disabled && (
                                    <div onClick={ (event) => handleClickCertificadoApremioPersonaRemove(data.value) } className="link">
                                        <span className="material-symbols-outlined" title="Eliminar">delete</span>
                                    </div>
                                    )}
                                </div>

    const getDescTipoRelacionCertificadoApremioPersona = (id) => {
        const row = getRowEntidad('TipoRelacionCertificadoApremioPersona', id);
        return (row) ? row.descripcion : '';
    }

    const getDescTipoDocumento = (id) => {
        const row = getRowLista('TipoDocumento', id);
        return (row) ? row.nombre : '';
    }

    const tableColumns = [
        { Header: 'Tipo relación', Cell: (data) => getDescTipoRelacionCertificadoApremioPersona(data.value), accessor: 'idTipoRelacionCertificadoApremioPersona', width: '20%' },
        { Header: 'Titular', Cell: (data) => 
                                    `${data.row.original.nombrePersona} 
                                    (${getDescTipoDocumento(data.row.original.idTipoDocumento)}
                                    ${data.row.original.numeroDocumento})`
                                    , width: '40%' },        
        { Header: 'Vigencia desde', Cell: (data) => getDateToString(data.value, false), accessor: 'fechaDesde', width: '15%' },
        { Header: 'Vigencia hasta', Cell: (data) => getDateToString(data.value, false), accessor: 'fechaHasta', width: '15%' },
        { Header: cellA, Cell: cellVMR, id:'abm', accessor: 'id', width: '10%', disableGlobalFilter: true, disableSortBy: true }
    ];

    //handles
    const handleClickCertificadoApremioPersonaAdd = () => {
        const idTemporal = (-1)*sequenceValue; //los registros temporales tienen id negativa
        setState(prevState => {
        const rowForm = {
            id: idTemporal,
            idCertificadoApremio: state.idCertificadoApremio,
            idTipoRelacionCertificadoApremioPersona: 0,
            fechaDesde: null,
            fechaHasta: null,
            idPersona: 0,
            state: 'a'
        };
        return {...prevState, showForm: true, modeFormEdit: true, rowForm: rowForm};
        });
        dispatch( sequenceActionNext() );
    }

    const handleClickCertificadoApremioPersonaView = (id) => {
        setState(prevState => {
        const rowForm = state.list.find(x => x.id === id);
        return {...prevState, showForm: true, modeFormEdit: false, rowForm: rowForm};
        });
    }

    const handleClickCertificadoApremioPersonaModify = (id) => {
        setState(prevState => {
        const rowForm = state.list.find(x => x.id === id);
        return {...prevState, showForm: true, modeFormEdit: true, rowForm: rowForm};
        });
    }
    
    const handleClickCertificadoApremioPersonaRemove = (id) => {
        const rowForm = state.list.find(x => x.id === id);
        showMessageModal({
            ...MESSAGE_MODALS.BORRAR,
            message: `¿Está seguro de borrar la persona ${rowForm.nombrePersona}?`,
            onConfirm: () => {
                props.onChange('CertificadoApremioPersona', { ...rowForm, state: 'r' })
            },
        })
    }

    // funciones
    function UpdateCertificadoApremioPersona(row) {
        row.state = isNull(state.list.find(x => x.id === row.id)) ? 'a' : 'm';
        props.onChange('CertificadoApremioPersona', row);
    }

    return (
    <>
        {state.showForm && 
            <CertificadoApremioPersonaModal
                processKey={props.processKey}
                disabled={!state.modeFormEdit}
                data={{
                    entity: state.rowForm
                }}
                onDismiss={() => {
                    setState(prevState => {
                        return {...prevState, showForm: false, rowForm: null};
                    });
                }}
                onConfirm={(row) => {
                    setState(prevState => {
                        return {...prevState, showForm: false, rowForm: null};
                    });
                    UpdateCertificadoApremioPersona(row);
                }}
            />
        }

        <TableCustom
            showFilterGlobal={false}
            className={'TableCustomBase'}
            columns={tableColumns}
            data={state.list}
        />

    </>
    );
}

CertificadoApremioPersonaGrid.propTypes = {
  processKey: string.isRequired,
  disabled: bool,
  data: object.isRequired,
  onChange: func.isRequired
};

CertificadoApremioPersonaGrid.defaultProps = {
  disabled: false
};

export default CertificadoApremioPersonaGrid;